import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../styles/logo.png';
import '../styles/LegalPage.css';

const Impressum = () => {
  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <div className="legal-container">
          <Link to="/" className="legal-logo">
            <img src={logoImage} alt="maiave Logo" className="legal-logo-image" />
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="legal-content">
        <div className="legal-container">
          <h1 className="legal-title">Impressum</h1>
          
          {/* 👇 HIER DEINEN INHALT EINFÜGEN */}
          <div className="legal-text">
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              Marc Wälde<br />
              Römerstraße 8<br />
              77955 Ettenheim
            </p>

            <h2>Kontakt</h2>
            <p>
              Telefon: 01551 0611906<br />
              E-Mail: info@immobilienverkauf-freiburg.de
            </p>

            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Marc Wälde<br />
              Römerstraße 8<br />
              77955 Ettenheim
            </p>

            <h2>EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>

            {/* Platzhalter für weitere Inhalte */}
          </div>
          {/* 👆 BIS HIER */}

          {/* Back Button */}
          <div className="legal-back">
            <Link to="/" className="legal-back-button">
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-container">
          <p>&copy; 2026 maiave. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;